import { motion } from "framer-motion";
import {
  FaCode,
  FaPaintBrush,
  FaDatabase,
  FaCogs,
  FaPlug,
  FaTachometerAlt,
  FaRobot,
  FaLaptopCode,
} from "react-icons/fa";

export default function Services() {
  const services = [
    {
      title: "Full-Stack Development",
      description:
        "We build scalable, high-performance applications with React, Node.js, and MongoDB.",
      icon: <FaCode />,
      color: "from-blue-500 to-indigo-500",
    },
    {
      title: "Custom Web Applications",
      description:
        "Develop tailored web solutions to meet your business needs, ensuring high performance and scalability.",
      icon: <FaLaptopCode />,
      color: "from-teal-500 to-green-500",
    },
    {
      title: "UI/UX Design",
      description:
        "Craft visually stunning and intuitive interfaces with Tailwind CSS and modern design principles.",
      icon: <FaPaintBrush />,
      color: "from-pink-500 to-red-500",
    },
    {
      title: "Database Management",
      description:
        "Secure and efficient data storage using MongoDB, PostgreSQL, and Firebase solutions.",
      icon: <FaDatabase />,
      color: "from-green-500 to-teal-500",
    },
    {
      title: "Website Maintenance",
      description:
        "Provide website maintenance and hosting services for smooth operations.",
      icon: <FaCogs />,
      color: "from-yellow-500 to-orange-500",
    },
    {
      title: "API Development",
      description:
        "Secure and scalable RESTful and GraphQL APIs for seamless integration.",
      icon: <FaPlug />,
      color: "from-cyan-500 to-blue-500",
    },
    {
      title: "AI-Powered Solutions",
      description:
        "Enhance your business with AI-driven automation, chatbots, and intelligent data analytics.",
      icon: <FaRobot />,
      color: "from-blue-600 to-purple-600",
    },
    {
      title: "Performance Optimization & SEO",
      description:
        "Boost website speed, enhance SEO, and improve Core Web Vitals for better rankings.",
      icon: <FaTachometerAlt />,
      color: "from-orange-500 to-yellow-500",
    },
  ];

  return (
    <section
      id="services"
      className="relative bg-black text-white py-24 px-4 sm:px-6 lg:px-16 overflow-hidden"
    >
      {/* Section Title */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-300">
          Our Services
        </h1>
        <p className="text-gray-300 text-base sm:text-lg mt-4 max-w-2xl mx-auto">
          Unlock the power of cutting-edge web solutions with our expertise.
        </p>
      </motion.div>

      {/* Service Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 justify-items-center">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.2, ease: "easeOut" },
            }}
            className="w-full max-w-[320px] bg-white/5 backdrop-blur-xl border border-white/10 p-6 rounded-2xl text-center hover:shadow-2xl transition-all duration-300"
          >
            <div
              className={`w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-white bg-gradient-to-br ${service.color} rounded-full shadow-md`}
            >
              {service.icon}
            </div>
            <h3 className="text-lg font-semibold text-white">{service.title}</h3>
            <p className="text-gray-400 mt-3 text-sm">{service.description}</p>
          </motion.div>
        ))}
      </div>

      {/* Floating Glow Background */}
      <motion.div
        animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.6, 0.3] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
        className="absolute -top-20 left-1/2 transform -translate-x-1/2 w-[500px] h-[500px] bg-blue-500/10 rounded-full blur-3xl pointer-events-none"
      ></motion.div>
    </section>
  );
}
